import { BaseTableTransformer } from './BootstrapTableTransformer';
import {
    PREDEFINED_ATTRIBS,
    ATTRIB_TYPE_ENUM_CUSTOM
} from '../../view/my-store/components/constants';

export class MarketplaceAttributionsTableTransformer extends BaseTableTransformer {
    transformColumns(columns) {
        columns.unshift({
            title: '',
            data_field: 'icon',
            data_type: 'attrib_icon'
        });
        return super.transformColumns(columns);
    }

    getIconEnumFromChannelName(channelName) {
        const found = PREDEFINED_ATTRIBS.find(a => a.typeLabel === channelName);
        return found ? found.typeEnum : ATTRIB_TYPE_ENUM_CUSTOM;
    }

    transformRows(rows) {
        const baseRows = super.transformRows(rows);
        const transformed = [];

        baseRows.forEach(row => {
            const iconEnum = this.getIconEnumFromChannelName(row.channel);
            const transformedRow = {
                icon: iconEnum,
                channel: row.channel,
                page_views: row.pageViews || 0,
                trials: row.trials || 0,
                purchases: row.purchases || 0,
                revenue: row.revenue || 0
            };
            transformed.push(transformedRow);
        });
        return transformed;
    }
}
